<div *ngIf="!isProSignupProcessgoin()">
  <div *ngIf="isShoppingFunnel">
    <div class="text-center mb-3" *ngIf="modePro && !loggedIn()">
      <div class="clr-white titi-web-black fs-31p">Vous êtes <span class="proOrganiser">organisateur d'évènement</span></div>
      <div class="clr-white titi-web-black fs-24p">{{'shared_sign_up_form.create_an_account_free'| translate}} !</div>
    </div>
    <div *ngIf = '!userIsSigned' class="row d-flex justify-content-center">
      <div [ngClass]="{'col-md-5': !full, 'col-md-12': full}">
      <!--  class="min-768pd-15-45p"-->
        <form (ngSubmit)="onSubmit(signUpForm.valid)" #signUpForm="ngForm" >
          <div class="form-group row has-danger" *ngIf="errorMsg">
            <div class="col-12">
              <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ errorMsg }}</div>
            </div>
          </div>
          <!-- firstname/lastname field -->
          <div class="form-group row" [ngClass]="{'has-danger':  firstname.errors && (firstname.dirty || firstname.valid || errors.length) }">
            <div class="col-lg-12 col-xs-12 rp-xs">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <!--<div class="input-group-addon"><i class="fa fa-user" aria-hidden="true"></i></div>-->
                <input class="form-control placeholder-custum h-50p border-radius-none" type="text" value="" id="firstname" name="firstname" placeholder="Nom" [(ngModel)]="account.firstname" #firstname="ngModel" required>
              </div>
              <div class="form-control-feedback input-error" *ngIf="firstname.errors && (firstname.dirty || firstname.touched || errors.length)">{{'shared_sign_up_form.your_lastname_is_required'| translate}}</div>
            </div>
          </div>

          <div class="form-group row" [ngClass]="{'has-danger': lastname.errors && (lastname.dirty || lastname.touched || errors.length)}">
            <div class="col-lg-12 col-xs-12 rp-xs">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <!--<div class="input-group-addon"><i class="fa fa-user" aria-hidden="true"></i></div>-->
                <input class="form-control placeholder-custum h-50p border-radius-none" type="text" value="" id="lastname" name="lastname" placeholder="Prénom" [(ngModel)]="account.lastname" #lastname="ngModel" required>
              </div>
              <div class="form-control-feedback input-error" *ngIf="lastname.errors && (lastname.dirty || lastname.touched || errors.length)"> {{'shared_sign_up_form.your_firstname_is_required'| translate}}</div>
            </div>

          </div>

          <!-- email field -->
          <div class="form-group row" [ngClass]="{'has-danger': email.errors && (email.dirty || email.touched || errors.length)}">
            <div class="col-12 rp-xs">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <!--<div class="input-group-addon"><i class="fa fa-envelope" aria-hidden="true"></i></div>-->
                <input class="form-control placeholder-custum h-50p border-radius-none" type="email" value="" id="email" name="email" placeholder="E-mail" [(ngModel)]="account.email" #email="ngModel" required email>
              </div>
              <div class="form-control-feedback input-error" *ngIf="email.errors && (email.dirty || email.touched || errors.length)"> Votre adresse email est requis ou invalide</div>
            </div>
          </div>
          <!-- password field -->
          <div class="form-group row" [ngClass]="{'has-danger':  password.errors && (password.dirty || password.touched || errors.length)}">
            <div class="col-12 rp-xs">
              <div class="input-group mb-2 custom-wrapper mr-sm-2 mb-sm-0">
                <!--<div class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></div>-->
                <input class="form-control placeholder-custum h-50p border-radius-none" [type]="hidePassword?'password':'text'" value="" id="password" name="password" placeholder="Mot de passe" [(ngModel)]="account.password"  #password="ngModel"  required>
                <i class="fa fa-eye input-icon" *ngIf="hidePassword" (click)="toglePasswordVisibility()"></i>
                <i class="fa fa-eye-slash input-icon" aria-hidden="true" *ngIf="!hidePassword" (click)="toglePasswordVisibility()"></i>
              </div>
              <div class="form-control-feedback input-error" *ngIf="password.errors && (password.dirty || password.touched || errors.length)"> mot de passe requis</div>
              <!--<div class="form-control-feedback" *ngIf="password.touched && password.length <8"><i class="fa fa-info-circle" aria-hidden="true"></i>{{'shared_sign_up_form.your_password_must_contains_at_least_8_characters'| translate}}</div>-->
            </div>
          </div>
          <div class="form-group row mt-35p">
            <div class="col-12 rp-xs max500mtb-10">
              <div class="form-check">
                <label class="form-check-label form-check-wrapper" style="align-items:center">
                  <input class="form-check-input mr-2 border-radius-none" (change)="condition=!condition" type="checkbox" [checked]="condition" value="">
                  <div class="max500fs14p">
                    <span class="uppercase">{{'shared_sign_up_form.i_accept_the'| translate}}</span>
                    <a [routerLink]="['/cg']" style="color: #00CCFF!important;" title="Conditions Générales"  class="text-italic uppercase">{{'shared_sign_up_form.terms_and_conditions'| translate}}</a>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <!-- submit button -->
          <div class="form-group row mt-30p">
            <div class="offset-sm-1 rp-xs col-sm-10 text-center">
              <button type="submit" class="btn-color uppercase clr-white sbmt-btn">créer un compte</button>
            </div>
          </div>
        </form>
        <div *ngIf="displayLinks && !modePro" class="center">
          <div class="my-3 text-right mb-5"><a routerLink="/login/signin">{{'shared_sign_up_form.already_member'| translate}}</a></div>
        </div>

        <div *ngIf="displayLinks && modePro" class="max500mt-15p">
          <div class="uppercase mb-5 wk-center link-color"><span class="clr-white">déja organisateur ? </span> <a style="border-bottom: 1px solid;color: #00CCFF!important;" routerLink="/login/signin">connectez-vous</a></div>
        </div>
      </div>
    </div>
    <div class="signup-congrat-box row" *ngIf="loggedIn()">
      <div class="col-md-8">
        <h1 class="signup-congrat-box__title">{{'shared_sign_up_form.welcome_on_akces'| translate}}</h1>
        <p class="signup-congrat-box__content">{{'shared_sign_up_form.congratulation'| translate}}, {{account.lastname+' '+account.firstname}} {{'shared_sign_up_form.your_account_has_benn_created_successfully'| translate}}<br/>
          {{'shared_sign_up_form.we_invite_you_to_create_your_first_event_or'| translate}}<br/>
          {{'shared_sign_up_form.to_configure_your_profl'| translate}}</p>
        <div class="signup-congrat-box__btns">
          <button  (click) = "moveToCreate()" class="signup-congrat-box__btn btn btn-primary" >
            {{'shared_sign_up_form.create_an_event'| translate}}
          </button>
          <button (click) = "moveToLink()" class="signup-congrat-box__btn btn btn-primary">
            {{'shared_sign_up_form.configure_my_profl'| translate}}
          </button>
        </div>
      </div>
      <div class="col-md-4">
        <img style="width : 100%;" src="/assets/imgs/welcome-settings.png" class="img-fluid" alt="Calandrier" />
      </div>
    </div>
  </div>
  <div *ngIf="!isShoppingFunnel" class="row col-md-12 pd-lr-0 mlr-0 heigh-mini">
    <div class="col-md-4 bloc-h-mini pd-lr-0 bg">

      <!--<div *ngIf="loggedIn()">
        <div class="signup-congrat-box row" *ngIf="loggedIn()">
          <div class="col-md-8">
            <h1 class="signup-congrat-box__title">{{'shared_sign_up_form.welcome_on_akces'| translate}}</h1>
            <p class="signup-congrat-box__content">{{'shared_sign_up_form.congratulation'| translate}}, {{account.lastname+' '+account.firstname}} {{'shared_sign_up_form.your_account_has_benn_created_successfully'| translate}}<br/>
              {{'shared_sign_up_form.we_invite_you_to_create_your_first_event_or'| translate}}<br/>
              {{'shared_sign_up_form.to_configure_your_profl'| translate}}</p>
            <div class="signup-congrat-box__btns">
              <button  (click) = "moveToCreate()" class="signup-congrat-box__btn btn btn-primary" >
                {{'shared_sign_up_form.create_an_event'| translate}}
              </button>
              <button (click) = "moveToLink()" class="signup-congrat-box__btn btn btn-primary">
                {{'shared_sign_up_form.configure_my_profl'| translate}}
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <img style="width : 100%;" src="/assets/imgs/welcome-settings.png" class="img-fluid" alt="Calandrier" />
          </div>
        </div>      </div>-->
      <div>
        <div class="center pd-100p">
          <a href="/" class="m-auto">
            <img style="width: 250px" class="m-auto" src="assets/imgs/{{logoName}}" alt="Logo Akces" id="logo">
          </a>
        </div>
        <div class="event-made-f-u event-made-f-u-mini">Une sélection <span style="color: #00CCFF!important;">d'évènements</span> faits pour vous </div>
        <div class="login-bloc">
          <div class=" create_ur_account create_ur_account-mini">
            <div>Créer un compte gratuitement !</div>
            <div class="registration">Inscription 100% gratuite sans engagement </div>
          </div>
          <form (ngSubmit)="onSubmit(signUpForm.valid)" #signUpForm="ngForm">
            <div class="form-group row has-danger" *ngIf="errorMsg">
              <div class="col-12">
                <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ errorMsg }}</div>
              </div>
            </div>
            <!-- firstname/lastname field -->
            <div class="form-group row" [ngClass]="{'has-danger':  firstname.errors && (firstname.dirty || firstname.valid || errors.length) }">
              <div class="col-lg-12 col-xs-12 rp-xs">
                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                  <!--<div class="input-group-addon"><i class="fa fa-user" aria-hidden="true"></i></div>-->
                  <input class="form-control placeholder-custum border-radius-none heigh-50" type="text" value="" id="firstname" name="firstname" placeholder="NOM" [(ngModel)]="account.firstname" #firstname="ngModel" required>
                </div>
                <div class="form-control-feedback input-error" *ngIf="firstname.errors && (firstname.dirty || firstname.touched || errors.length)">{{'shared_sign_up_form.your_lastname_is_required'| translate}}</div>
              </div>
            </div>

            <div class="form-group row" [ngClass]="{'has-danger': lastname.errors && (lastname.dirty || lastname.touched || errors.length)}">
              <div class="col-lg-12 col-xs-12 rp-xs">
                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                  <!--<div class="input-group-addon"><i class="fa fa-user" aria-hidden="true"></i></div>-->
                  <input class="form-control placeholder-custum border-radius-none heigh-50" type="text" value="" id="lastname" name="lastname" placeholder="PRENOM" [(ngModel)]="account.lastname" #lastname="ngModel" required>
                </div>
                <div class="form-control-feedback input-error" *ngIf="lastname.errors && (lastname.dirty || lastname.touched || errors.length)"> {{'shared_sign_up_form.your_firstname_is_required'| translate}}</div>
              </div>
            </div>

            <!-- email field -->
            <div class="form-group row" [ngClass]="{'has-danger': email.errors && (email.dirty || email.touched || errors.length)}">
              <div class="col-12 rp-xs">
                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                  <!--<div class="input-group-addon"><i class="fa fa-envelope" aria-hidden="true"></i></div>-->
                  <input class="form-control placeholder-custum border-radius-none heigh-50" type="email" value="" id="email" name="email" placeholder="E-MAIL" [(ngModel)]="account.email" #email="ngModel" required email>
                </div>
                <div class="form-control-feedback input-error" *ngIf="email.errors && (email.dirty || email.touched || errors.length)"> Votre adresse e-mail est requise ou invalide</div>
              </div>
            </div>
            <!-- password field -->
            <div class="form-group row" [ngClass]="{'has-danger':  password.errors && (password.dirty || password.touched || errors.length)}">
              <div class="col-12 rp-xs">
                <div class="input-group mb-2 custom-wrapper mr-sm-2 mb-sm-0">
                  <!--<div class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></div>-->
                  <input class="form-control placeholder-custum border-radius-none heigh-50" [type]="hidePassword?'password':'text'" value="" id="password" name="password" placeholder="Mot de passe" [(ngModel)]="account.password"  #password="ngModel"  required>
                  <i class="fa fa-eye input-icon" *ngIf="hidePassword" (click)="toglePasswordVisibility()"></i>
                  <i class="fa fa-eye-slash input-icon" aria-hidden="true" *ngIf="!hidePassword" (click)="toglePasswordVisibility()"></i>
                </div>
                <div class="form-control-feedback input-error" *ngIf="password.errors && (password.dirty || password.touched || errors.length)"> mot de passe requis ou invalide</div>
                <!--<div class="form-control-feedback" *ngIf="password.touched && password.length <8"><i class="fa fa-info-circle" aria-hidden="true"></i>{{'shared_sign_up_form.your_password_must_contains_at_least_8_characters'| translate}}</div>-->
              </div>
            </div>
            <div class="form-group row">
              <div class="col-12 rp-xs max500mtb-10">
                <div class="form-check">
                  <label class="form-check-label form-check-wrapper" style="align-items:center">
                    <input class="form-check-input mr-2 border-radius-none" (change)="condition =! condition" type="checkbox" [checked]="condition" value="">
                    <div class="max500fs14p">
                      <span>{{'shared_sign_up_form.i_accept_the'| translate}}</span>
                      <a [routerLink]="['/cg']" title="Conditions Générales"  class="text-italic ft-size-11-mini color-gb">{{'shared_sign_up_form.terms_and_conditions'| translate}}</a>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <!-- submit button -->
            <div class="form-group row ">
              <div class="offset-sm-1 rp-xs col-sm-10 text-center">
                <button type="submit" class="su-btn btn-color uppercase">créer un compte</button>
              </div>
            </div>
          </form>
        </div>
        <div class="center uppercase not-have-account mt-40p">
          <div class="m-auto">déja membre ? <a routerLink="/login/signin" class="color-gb">connectez-vous</a></div>
        </div>
      </div>
    </div>
    <div class="col-md-8 bgImagePro {{modePro?'bgImagePro':'bgImage'}}  pd-lr-0 hide-second-bloc-mini second-bloc-none"></div>
  </div>
</div>

<div class="container-fluid" *ngIf="isProSignupProcessgoin()">
  <div  class="row">
    <div class="col-md-5 signup-step-bg">
      <div class="text-left mb-20p mt-85p signup-setp-logo-mg">
        <a [routerLink]="['/']"><img src="assets/imgs/logo-pro.png" alt="Logo Akces" id="logo"></a>
      </div>
      <div class="mt-90p text-left" style="margin-left: 24px;" *ngIf="orgaSignupStepCurrentIdx < 4">
          <div *ngFor="let step of orgaSignupSteps" class="inline-block mr-15p">
            <div class="inline-block oga-signup-step-index {{orgaSignupStepCurrentIdx == step.index?'fs-12p current-step current-step-index-border':'fs-10p step-index-border' }}">{{step.index}}</div>
            <div class="inline-block oga-signup-step-name pointer uppercase {{orgaSignupStepCurrentIdx == step.index?'fs-14p current-step-color':'fs-12p' }}" (click)="clickOrgaSignupStep(step.index)">{{step.name}}</div>
          </div>
          <div *ngIf="orgaSignupStepCurrentIdx == 2">
             <div class="text-left mt-50p create-orga-profil">
               <div>Créer votre <br> profil <br> organisateur </div>
             </div>
            <div class="clr-white uppercase tell-us-about-you">avant de vous lancer, dites-nous en un peu plus sur vous... </div>
          </div>
          <div *ngIf="orgaSignupStepCurrentIdx == 3">
            <div class="text-left mt-50p create-orga-profil">
              <div>Renseignez vos  <br> coordonnées </div>
            </div>
            <div class="clr-white uppercase tell-us-about-you">plus qu'une étape ! pas de panique... <br>
              avec nous, vos données sont sécurisées.
            </div>
          </div>
      </div>
      <div *ngIf="orgaSignupStepCurrentIdx == 4" style="margin-top: 90px;" class="pl-50p">
        <div class="congrats"><img height="45" class="congrats-icon" src="assets/imgs/pro_congrats_icon.png" alt="">Félicitations !</div>
        <div class="uppercase clr-white mt-40p">Lancez vous dès maintenant en créant  votre tout premier évènement sur akces !</div>
      </div>
    </div>
    <div class="col-md-7 pd-lr-0 webkit-center">
      <div class="mt-50p" *ngIf="orgaSignupStepCurrentIdx == 2">
        <div class="col-md-7">
          <div>
            <span class="uppercase">Votre logo</span>
            <div *ngIf="!organisation.logo" style="background-color: #00CCFF" class="orga-logo orga-logo-margin-t" title="Cliquez pour charger votre logo" (click)="selectFile($event)">
              <div style="margin-top: 12px;color: #D5F7FF!important;">
                <span style="font-size: 45px;margin-left: auto">{{initials()}}</span>
              </div>
            </div>
            <div class="orga-logo orga-logo-margin-t" *ngIf="organisation.logo"><img class="orga-logo-img" [src]="organisation.logo |assetimage" alt=""></div>
            <input type="file" style="visibility: hidden" class="form-control-file" (change)="inputLogoImageListener($event)" name="image" id="image">
            <button (click)="selectFile($event)" style="margin-bottom: 15px" *ngIf="organisation.logo">Editer le logo</button>
          </div>
          <form (ngSubmit)="orgaDataSubmit(orgaDataForm.valid)"  #orgaDataForm="ngForm">
            <div class="form-group row has-danger" *ngIf="errorMsg">
              <div class="col-12">
                <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ errorMsg }}</div>
              </div>
            </div>
            <div class="form-group row" [ngClass]="{'has-danger':  orgaName.errors && (orgaName.dirty || orgaName.valid || orgaDataFormerrors.length) }">
              <label for="orgaName" class="text-left">NOM ORGANISATION</label>
              <input class="form-control placeholder-custum border-radius-none heigh-50" type="text" value="" id="orgaName" name="orgaName" [(ngModel)]="organisation.name" #orgaName="ngModel">
              <div class="form-control-feedback input-error" *ngIf="orgaName.errors && (orgaName.dirty || orgaName.touched || errors.length)">le nom est requis</div>
            </div>

            <div class="form-group row" [ngClass]="{'has-danger': organisation.orgaType == 'choose' && (orgaType.dirty || orgaType.touched || orgaDataFormerrors.length)}">
               <label for="orgaType" class="text-left">TYPE D'ORGANISATION</label>
                <select id="orgaType"  [(ngModel)]="organisation.orgaType" #orgaType="ngModel" name="orgaType" class="form-control placeholder-custum border-radius-none heigh-50">
                  <option value="choose">Choisissez</option>
                  <ng-container *ngFor="let type of orgaTypeList">
                    <option [value]="type">{{type}}</option>
                  </ng-container>
                </select>
               <!--<div class="form-control-feedback input-error" *ngIf="organisation.orgaType == 'choose' && (orgaType.dirty || orgaType.touched || errors.length)">le type d'organisation est requis</div>-->
            </div>


            <div class="form-group row" [ngClass]="{'has-danger': organisation.eventType == 'choose' && (eventType.dirty || eventType.touched || orgaDataFormerrors.length)}">
                <label for="eventType" class="text-left">TYPES D'EVENEMENT</label>
                <select id="eventType"  [(ngModel)]="organisation.eventType" #eventType="ngModel" name="eventType" class="form-control placeholder-custum border-radius-none heigh-50">
                   <option value="choose">Choisissez</option>
                   <ng-container *ngFor="let type of eventTypeList">
                      <option [value]="type">{{type}}</option>
                   </ng-container>
                </select>
                <!--<div class="form-control-feedback input-error" *ngIf="organisation.eventType == 'choose' && (eventType.dirty || eventType.touched || errors.length)">le type d'évènement est requis</div>-->
            </div>

            <div class="form-group row" [ngClass]="{'has-danger': orgaTelephone.errors && (orgaTelephone.dirty || orgaTelephone.touched || orgaDataFormerrors.length)}">
              <label for="orgaTelephone" class="text-left"><span>TELEPHONE</span><br>
              <span style="font-size: 12px">Seulement utilisé par nos conseillers pour vous aider.</span></label>
              <div></div>
              <input class="form-control placeholder-custum border-radius-none heigh-50" type="number" value="" id="orgaTelephone" name="orgaTelephone" placeholder="" [(ngModel)]="organisation.phone" #orgaTelephone="ngModel">
               <div class="form-control-feedback input-error" *ngIf="orgaTelephone.errors && (orgaTelephone.dirty || orgaTelephone.touched || errors.length)">le téléphone est requis</div>
            </div>

            <div class="form-group row " style="display: none">
              <div class="offset-sm-1 rp-xs col-sm-10 text-center">
                <button type="submit" id="orgaDataBtn" class="su-btn btn-color">addorgaData</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="mt-100p" *ngIf="orgaSignupStepCurrentIdx == 3">
        <div class="col-md-8">
          <form (ngSubmit)="paymentDataSubmit(paymentDataForm.valid)"  #paymentDataForm="ngForm">
            <div class="form-group row" [ngClass]="{'has-danger':  domiciliation.errors && (domiciliation.dirty || domiciliation.valid || paymentDataFormerrors.length) }">
                 <label for="domiciliation" class="text-left">Domiciliation</label>
                 <input class="form-control placeholder-custum border-radius-none heigh-50" type="text" value="" id="domiciliation" name="domiciliation" placeholder="" [(ngModel)]="payment.domiciliation" #domiciliation="ngModel">
                 <div class="form-control-feedback input-error" *ngIf="domiciliation.errors && (domiciliation.dirty || domiciliation.touched || errors.length)"><i class="fa fa-info-circle" aria-hidden="true"></i>le domiciliation est requise</div>
            </div>

            <div class="form-group row">
              <div class="col-lg-6 col-xs-6 text-left rp-xs pd-l-0p" [ngClass]="{'has-danger': iban.errors && (iban.dirty || iban.touched || paymentDataFormerrors.length)}">
                  <label for="iban" class="">IBAN</label>
                  <input class="form-control placeholder-custum border-radius-none heigh-50" type="text" value="" id="iban" name="iban" placeholder="" [(ngModel)]="payment.iban" #iban="ngModel">
                  <div class="form-control-feedback input-error" *ngIf="iban.errors && (iban.dirty || iban.touched || paymentDataFormerrors.length)"><i class="fa fa-info-circle" aria-hidden="true"></i>l'iban est requis</div>
              </div>

              <div class="col-lg-6 col-xs-6 rp-xs text-left pd-r-0p" [ngClass]="{'has-danger': bic.errors && (bic.dirty || bic.touched || paymentDataFormerrors.length)}">
                  <label for="bic" class="text-left">IBAN</label>
                  <input class="form-control placeholder-custum border-radius-none heigh-50" type="text" value="" id="bic" name="bic" placeholder="" [(ngModel)]="payment.bic" #bic="ngModel">
                  <div class="form-control-feedback input-error" *ngIf="bic.errors && (bic.dirty || bic.touched || paymentDataFormerrors.length)"><i class="fa fa-info-circle" aria-hidden="true"></i>le bic est requis</div>
              </div>
            </div>

            <div class="form-group row" [ngClass]="{'has-danger': owner.errors && (owner.dirty || owner.touched || paymentDataFormerrors.length)}">
                <label for="owner" class="text-left">Propriétaire du compte</label>
                <input class="form-control placeholder-custum border-radius-none heigh-50" type="text" value="" id="owner" name="owner" placeholder="" [(ngModel)]="payment.Titulaire" #owner="ngModel">
                <div class="form-control-feedback input-error" *ngIf="owner.errors && (owner.dirty || owner.touched || paymentDataFormerrors.length)"><i class="fa fa-info-circle" aria-hidden="true"></i>le propriétaire du compte est requis</div>
            </div>

            <div class="text-left" style="margin-left: -15px;margin-right: -15px">
              <label class="text-left">Téléchargez votre IBAN ou RIB au format PDF</label>
              <div class="signup-download-bic-rib" (click)="selectFileribibanpdf($event)"></div>
              <input  (change)="inputPdfChangeListener($event)" id="iban_rib_pdf" type="file" class="form-control-file_rib_iban" style="visibility: hidden">
            </div>

            <div class="form-group row " style="display: none">
              <div class="offset-sm-1 rp-xs col-sm-10 text-center">
                <button type="submit" id="addPaymentData" class="su-btn btn-color">addPaymentData</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="sep-four-bg center-f" *ngIf="orgaSignupStepCurrentIdx == 4">
        <div  style="width: -webkit-fill-available;">
          <div class="r_u_ready">Vous êtes prêts?</div>
          <a  [routerLink]="['/manage/event/create']"  title="Créer un évènement" class="uppercase create-event-link">Créer votre évènement </a>
        </div>
      </div>
    </div>
    <div class="col-md-12 h-80p signup-step-bg center">
      <button class="uppercase ml-auto clr-white step-next-btns bg-ligth_g" (click)="passStep()">passer</button>
      <button class="uppercase btn-color clr-white step-next-btns ml-15p" *ngIf="orgaSignupStepCurrentIdx != 4" (click)="nextStep()">poursuivre</button>
    </div>
  </div>
</div>
